import { render, staticRenderFns } from "./SportMembershipsEmailsNew.vue?vue&type=template&id=2a62c150&scoped=true"
import script from "./SportMembershipsEmailsNew.vue?vue&type=script&lang=js"
export * from "./SportMembershipsEmailsNew.vue?vue&type=script&lang=js"
import style0 from "./SportMembershipsEmailsNew.vue?vue&type=style&index=0&id=2a62c150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62c150",
  null
  
)

export default component.exports